var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "baseInfoManage" },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "110px"
          }
        },
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              Object.keys(_vm.deliveryObj).length < 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "房间", prop: "upIdList" } },
                    [
                      _c("el-cascader", {
                        staticClass: "form-item-width",
                        attrs: {
                          options: _vm.options,
                          props: _vm.propstree,
                          placeholder: "请选择房间"
                        },
                        on: { change: _vm.checkSelectHouse },
                        model: {
                          value: _vm.childData.upIdList,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "upIdList", $$v)
                          },
                          expression: "childData.upIdList"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              Object.keys(_vm.deliveryObj).length > 0
                ? _c(
                    "el-form-item",
                    { attrs: { label: "房间" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        attrs: { disabled: "" },
                        model: {
                          value: _vm.childData.houseCode,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "houseCode", $$v)
                          },
                          expression: "childData.houseCode"
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "房间面积" } },
                [
                  _c("el-input", {
                    staticStyle: { width: "240px" },
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.childData.houseUseArea,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "houseUseArea", $$v)
                      },
                      expression: "childData.houseUseArea"
                    }
                  }),
                  _vm._v(" m² ")
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "接待人" } },
                [
                  _c("el-input", {
                    staticClass: "form-item-width",
                    attrs: { disabled: "" },
                    model: {
                      value: _vm.childData.userName,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "userName", $$v)
                      },
                      expression: "childData.userName"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "接房日期", prop: "statusDate" } },
                [
                  _c("el-date-picker", {
                    staticStyle: { width: "270px" },
                    attrs: {
                      "value-format": "yyyy-MM-dd",
                      type: "date",
                      placeholder: "请选择接房日期"
                    },
                    model: {
                      value: _vm.childData.statusDate,
                      callback: function($$v) {
                        _vm.$set(_vm.childData, "statusDate", $$v)
                      },
                      expression: "childData.statusDate"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-col",
            { attrs: { span: 24 } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "仪表初始读数" } },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.list,
                        border: "",
                        stripe: "",
                        fit: "",
                        "highlight-current-row": ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          type: "index",
                          label: _vm.$t("table.id"),
                          width: "50"
                        }
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "仪表名称" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.meterName))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "仪表类型" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.meterType))
                                ])
                              ]
                            }
                          }
                        ])
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "初始读数" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("span", [
                                  _vm._v(_vm._s(scope.row.initReadNumber))
                                ])
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handBindingCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handUpdate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }